var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.093,
    height: 16.296,
    viewBox: "0 0 19.093 16.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-store",
    "data-name": "Icon awesome-store",
    d: "M18.663,3.775,16.652.477A.987.987,0,0,0,15.812,0H3.288a.987.987,0,0,0-.84.477L.436,3.775A2.857,2.857,0,0,0,2.259,8.116a3.139,3.139,0,0,0,.425.029A3.027,3.027,0,0,0,4.971,7.091a3.011,3.011,0,0,0,4.575,0,3.011,3.011,0,0,0,4.575,0A3.037,3.037,0,0,0,16.41,8.145a3.1,3.1,0,0,0,.425-.029A2.854,2.854,0,0,0,18.663,3.775ZM16.416,9.167a3.836,3.836,0,0,1-.914-.121v3.177H3.6V9.046a4.005,4.005,0,0,1-.914.121,4.075,4.075,0,0,1-.558-.038,3.811,3.811,0,0,1-.508-.115v6.264A1,1,0,0,0,2.609,16.3H16.5a1,1,0,0,0,.992-1.019V9.014a3.094,3.094,0,0,1-.508.115A4.2,4.2,0,0,1,16.416,9.167Z",
    transform: "translate(-0.004)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.d2a976955a6602b1997dcb2a5da306cd.svg";
export { ForwardRef as ReactComponent };